<template>
  <section>
    <div class="container">
      <div class="is-col-12-md">
        <h1>Change password</h1>
        <p>Enter your new password below.</p>
      </div>
      <div class="is-col-12-md">
        <form id="changePasswordForm" @submit.prevent="sendFormData()">
          <div class="form-row-1">
            <div class="form-field">
              <label>New password</label> <input class="input-field" v-model="newPassword" type="password"
                                                 :class="{ invalid: errors.password }"
                                                 @input="clear_error('password')"/>
              <p class="errorMsg-text" v-if="errors.password">
                {{ errors.password | cleanError }} </p>
            </div>
            <div class="form-field name-field">
              <label>Confirm password</label> <input class="input-field" v-model="confirmPassword" type="password"
                                                     @input="clear_error('confirm_password')" :class="{
                  invalid:
                    errors.password_confirm || newPassword != confirmPassword,
                }"/>
              <p class="errorMsg-text" v-if="errors.password_confirm">
                {{ errors.password_confirm[0] }} </p>
            </div>
          </div>
          <p class="errorMsg-text" v-if="errors.length != 0">
            Please check that both passwords match and are a minimum of 8 characters. </p>
          <button>
            Change Password <span><i class="fas fa-caret-right"></i></span>
          </button>
          <button v-on:click="cancelForm" style="margin-left:1rem">
            Cancel <span><i class="fas fa-caret-right"></i></span>
          </button>
          <div class="loader-container" v-show="showLoader">
            <img src="@/assets/images/global/loader.gif" alt=""/>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      newPassword: '',
      confirmPassword: '',
      errors: [],
      token: '',
      showLoader: false
    }
  },
  mounted () {
    this.token = this.$route.query.token
  },
  created () {},
  methods: {
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') { delete this.errors[field] }
    },
    cancelForm (e) {
      e.preventDefault()
      this.$router.push({ name: 'AccountDetail' })
    },
    sendFormData () {
      const _this = this
      const headers = {}

      if (typeof _this.token !== 'undefined' && _this.token.length > 0) {
        headers.Authorization = 'Bearer ' + _this.token
      }
      _this.showLoader = true
      _this.axios.post(
        _this.$apiUrl + 'v1/changePassword',
        {
          token: _this.token,
          password: _this.newPassword,
          confirm_password: _this.confirmPassword
        },
        { headers }
      ).then(function (response) {
        _this.showResponse = true
        if (response.data.errors.length === 0) {
          _this.$store.state.pwReset = true
          _this.$router.push({ name: 'AccountDetail' }).catch(() => {})
        } else {
          _this.errors = response.data.errors
          _this.showLoader = false
        }
        _this.showResponse = true
      }).catch(function (error) {
        _this.showLoader = false
        _this.errors = error.response.data.errors
        setTimeout(() => {
          document.querySelector('input.invalid,select.invalid').focus()
        }, 200)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  text-align: left;
  margin-top: 65px;
  text-transform: uppercase;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-top: 1.1em;
    font-size: 45px;
    text-align: center;
  }
}

.container {
  // padding-left: 0;
  @media screen and (max-width: 1200px) {
    // padding-left: 7%;
  }

  p {
    font-size: 18px;
  }
}

.form-field {
  margin-bottom: 3rem;

  .errorMsg-text {
    margin-top: .5rem;
    font-size: 1.5rem;
  }
}

.input-field {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 0rem;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }
}

form {
  margin-top: 40px;

  button {
    margin-top: 40px;
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;

    span {
      margin-left: 7px;
    }

    @media screen and (max-width: 1000px) {
      width: 226px;
      font-size: 18px;
    }

    .fa-caret-right {
      margin-left: 7px;
      @media screen and (max-width: 1000px) {
        margin-left: 3px;
      }
    }
  }
}

.loader-container {
  display: inline-block;
  position: relative;
  margin-left: 2rem;
  top: 1rem;
}
</style>
